/*
 * Syntatic sugar
 */
export const qs = x => document.querySelector(x);

export const qsa = x => document.querySelectorAll(x);

/*
 * Get query values on URL
 */
export function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[\[\]]/g, "\\$&");

  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);

  if (!results) {
    return null;
  }

  if (!results[2]) {
    return "";
  }

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/*
 * Automatically insert UTM variables on forms
 */
export function insertUtmInForms() {
  var utmList = ["utm_source", "utm_medium", "utm_campaign"],
    check = "";

  for (var i = 0; i < utmList.length; i++) {
    check = getParameterByName(utmList[i]);
    if (check !== null && check !== "") {
      insertUtmInFormsFields(utmList[i], check);
    }
  }
}

export function insertUtmInFormsFields(name, value) {
  if (qs("form")) {
    const node = document.createElement("input");
    node.type = "hidden";
    node.name = name;
    node.value = value;
    qs("form").prepend(node);
  }
}

insertUtmInForms();

/*
 * Replace all SVG images with inline SVG
 */
export function embbedSvgImages() {
  var parser = new DOMParser();

  qsa("img.svg").forEach(function(item, index) {
    //console.log('item',item);
    var img = item;
    var imgID = img.id;
    var imgClass = img.classList.item(0);
    var imgURL = img.getAttribute("src");

    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = function() {
      if (
        httpRequest.readyState === XMLHttpRequest.DONE &&
        httpRequest.status === 200
      ) {
        var data = httpRequest.responseText;
        var doc = parser.parseFromString(data, "image/svg+xml");

        var svg = doc.querySelector("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          svg.setAttribute("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          svg.classList.add(imgClass);
          svg.classList.add("replaced-svg");
        }

        svg.removeAttribute("xmlns:a");

        img.parentNode.appendChild(svg);
        img.remove();
      }
    };
    httpRequest.open("GET", imgURL);
    httpRequest.send();
  });
}

/*
 * pure JS fade
 */

export function _(el) {
  if (!(this instanceof _)) {
    return new _(el);
  }
  this.el = document.getElementById(el);
}

_.prototype.fade = function fade(type, ms) {
  var isIn = type === "in",
    opacity = isIn ? 0 : 1,
    interval = 50,
    duration = ms,
    gap = interval / duration,
    self = this;

  if (isIn) {
    self.el.style.display = "inline";
    self.el.style.opacity = opacity;
  }

  function func() {
    opacity = isIn ? opacity + gap : opacity - gap;
    self.el.style.opacity = opacity;

    if (opacity <= 0) self.el.style.display = "none";
    if (opacity <= 0 || opacity >= 1) window.clearInterval(fading);
  }

  var fading = window.setInterval(func, interval);
};

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
export function getClosest(elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches =
      Element.prototype.matchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector ||
      Element.prototype.oMatchesSelector ||
      Element.prototype.webkitMatchesSelector ||
      function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
  }

  // Get closest match
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/assets/js/functions-vanilla.js